import { Injectable } from '@angular/core';
import { UserService } from '~services/user.service';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AdminRouteGuard {
  constructor(public userService: UserService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.userService.isAdmin() || this.userService.isDispatcher()) {
      return true;
    }

    if (this.userService.isLMOAccount()) {
      this.router.navigate(['/', 'lmo', 'frac', 'list']);
    }

    return false;
  }
}
